var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "auction_land_fields pt-3 pb-3" },
    [
      _vm.draw_pull_head.length > 0
        ? _c("b-container", { attrs: { fluid: "" } }, [
            _c("h1", { staticClass: "title text-center pt-5 pb-5 mt-5" }, [
              _vm._v("\n            Інформація про лот\n        "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "main_info" },
              [
                _vm._l(this.draw_pull_head, function (field) {
                  return _c(
                    "b-row",
                    { key: field.id, staticClass: "doc_title mt-4" },
                    [
                      _c("b-col", { attrs: { sm: "3" } }, [
                        _c(
                          "label",
                          {
                            staticClass: "fs-xl",
                            attrs: { for: field.field_type + field.id },
                          },
                          [_vm._v(_vm._s(field.field_name) + " ")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          field.field_type == "total_lot_cost"
                            ? _c(
                                "div",
                                {
                                  staticClass: "edit_text",
                                  on: {
                                    click: function ($event) {
                                      return _vm.edit_field(field)
                                    },
                                  },
                                },
                                [_c("fa", { attrs: { icon: _vm.faEdit } })],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("b-form-input", {
                            staticClass: "fs-xl",
                            attrs: { type: "text", disabled: true, size: "sm" },
                            model: {
                              value: field.field_val_to_show,
                              callback: function ($$v) {
                                _vm.$set(field, "field_val_to_show", $$v)
                              },
                              expression: "field.field_val_to_show",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.square_cost > 0
                  ? _c(
                      "b-row",
                      { key: "square_cost", staticClass: "doc_title mt-4" },
                      [
                        _c("b-col", { attrs: { sm: "3" } }, [
                          _c(
                            "label",
                            {
                              staticClass: "fs-xl",
                              attrs: { for: "square_cost" },
                            },
                            [_vm._v("Вартість 1 Га, грн")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "9" } },
                          [
                            _c("b-form-input", {
                              staticClass: "fs-xl",
                              attrs: {
                                type: "text",
                                disabled: true,
                                size: "sm",
                              },
                              model: {
                                value: new Intl.NumberFormat().format(
                                  _vm.square_cost
                                ),
                                callback: function ($$v) {
                                  _vm.$set(
                                    new Intl.NumberFormat(),
                                    "format(square_cost)",
                                    $$v
                                  )
                                },
                                expression:
                                  "new Intl.NumberFormat().format(square_cost)",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.op_years > 0
                  ? _c(
                      "b-row",
                      { key: "op_year", staticClass: "doc_title mt-4" },
                      [
                        _c("b-col", { attrs: { sm: "3" } }, [
                          _c(
                            "label",
                            {
                              staticClass: "fs-xl",
                              attrs: { for: "op_in_year" },
                            },
                            [_vm._v("Окупність лота в роках")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "9" } },
                          [
                            _c("b-form-input", {
                              staticClass: "fs-xl",
                              attrs: {
                                type: "text",
                                disabled: true,
                                size: "sm",
                              },
                              model: {
                                value: _vm.op_years,
                                callback: function ($$v) {
                                  _vm.op_years = $$v
                                },
                                expression: "op_years",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.op_year_ga > 0
                  ? _c(
                      "b-row",
                      { key: "op_in_year", staticClass: "doc_title mt-4" },
                      [
                        _c("b-col", { attrs: { sm: "3" } }, [
                          _c(
                            "label",
                            {
                              staticClass: "fs-xl",
                              attrs: { for: "op_in_year" },
                            },
                            [
                              _vm._v(
                                "Актуальна сума ОП в рік на 1 Га, чистими на руки"
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "9" } },
                          [
                            _c("b-form-input", {
                              staticClass: "fs-xl",
                              attrs: {
                                type: "text",
                                disabled: true,
                                size: "sm",
                              },
                              model: {
                                value: new Intl.NumberFormat().format(
                                  _vm.op_year_ga
                                ),
                                callback: function ($$v) {
                                  _vm.$set(
                                    new Intl.NumberFormat(),
                                    "format(op_year_ga)",
                                    $$v
                                  )
                                },
                                expression:
                                  "new Intl.NumberFormat().format(op_year_ga)",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.op_percent_year > 0
                  ? _c(
                      "b-row",
                      { key: "op_perc_year", staticClass: "doc_title mt-4" },
                      [
                        _c("b-col", { attrs: { sm: "3" } }, [
                          _c(
                            "label",
                            {
                              staticClass: "fs-xl",
                              attrs: { for: "op_perc_year" },
                            },
                            [_vm._v("Доходність ЗД в рік, %")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "9" } },
                          [
                            _c("b-form-input", {
                              staticClass: "fs-xl",
                              attrs: {
                                type: "text",
                                disabled: true,
                                size: "sm",
                              },
                              model: {
                                value: _vm.op_percent_year,
                                callback: function ($$v) {
                                  _vm.op_percent_year = $$v
                                },
                                expression: "op_percent_year",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.draw_isp_field.length > 0
        ? _c("b-container", { staticClass: "mb-2", attrs: { fluid: "" } }, [
            _c("h1", { staticClass: "title text-center pt-5 pb-5 mt-5" }, [
              _vm._v(
                "\n            Реквізити по оформленню документів\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "main_info" },
              _vm._l(this.draw_isp_field, function (field) {
                return _c(
                  "b-row",
                  { key: field.id, staticClass: "doc_title mt-4" },
                  [
                    _c("b-col", { attrs: { sm: "3" } }, [
                      _c(
                        "label",
                        {
                          staticClass: "fs-xl",
                          attrs: { for: field.type + field.id },
                        },
                        [_vm._v(_vm._s(field.name) + " ")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "9" } },
                      [
                        _c("b-form-input", {
                          staticClass: "fs-xl",
                          attrs: { type: "text", disabled: true, size: "sm" },
                          model: {
                            value: field.value,
                            callback: function ($$v) {
                              _vm.$set(field, "value", $$v)
                            },
                            expression: "field.value",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-tabs",
        { attrs: { "content-class": "mt-3" } },
        _vm._l(this.draw_pull_items, function (tab, index) {
          return _c(
            "b-tab",
            {
              key: index,
              attrs: {
                "active-nav-item-class":
                  "font-weight-bold text-uppercase text-danger",
                active: tab.is_active,
              },
              on: {
                click: function ($event) {
                  return _vm.set_pull_active(tab)
                },
              },
            },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _c("div", { staticClass: "icon-stack fs-xxl" }, [
                    _c("i", {
                      staticClass:
                        "base base-7 icon-stack-2x opacity-100 color-primary-500",
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "fal fa-globe-americas icon-stack-1x opacity-100 color-white",
                    }),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.get_tab_pull_title(index)) +
                      "\n                "
                  ),
                  tab.is_load
                    ? _c("b-spinner", { attrs: { type: "grow", small: "" } })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("pai_tab", {
                attrs: {
                  owner: _vm.owner_str,
                  pai_item: tab,
                  id: "pull_info" + index,
                },
              }),
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }